import { isNodeList } from "./isNodeList";
import { hasClass } from './hasClass';

export const removeClass = (els: any, str: string) => {
  if (!els) return;
  els = typeof (els) === 'string' ? document.querySelectorAll(els) : (isNodeList(els) || els instanceof Array) ? els : [els];
  els.forEach((item: any) => {
    if (hasClass(item, str)) { item.classList.remove(str); }
  });

};
